export default __webpack_public_path__ + "static/media/aboutBg.69c39ea2.mp4";